import phoneFlowStore from '../../Auth0LoginSteps/store/phoneFlow';
import tokenFlowStore from '../../Auth0LoginSteps/store/tokenFlow';
import resendCodeStore from '../../Auth0LoginSteps/store/resendCode';
import verifyCodeStore from '../../Auth0LoginSteps/store/verifyCode';
import trustPickerStore from '../../Auth0LoginSteps/store/trustPicker';
import customersStore from '../../Auth0LoginSteps/store/association/getCustomers';
import associationStore from '../../Auth0LoginSteps/store/association';

import { GetPasswordlessFlowState } from '../../Auth0LoginSteps/domain/phoneFlow/index';
import { GetTokenFlowState } from '../../Auth0LoginSteps/domain/tokenFlow/index';
import { SetResendCodeState, } from '../../Auth0LoginSteps/domain/resendCode/index';
import { SetVerifyCodeState } from '../../Auth0LoginSteps/domain/verifyCode/index';
import { GetCustomerCodeState } from '../../Auth0LoginSteps/domain/trustPicker/index';
import { GetAssociationFlowState, GetCustomersShortNameAndCodeState } from '../../Auth0LoginSteps/domain/association/index';
import { logger } from '../store/middlewares';

export interface IState {
	phoneFlow: GetPasswordlessFlowState;
	tokenFlow: GetTokenFlowState;
	resendCode: SetResendCodeState;
	verifyCode: SetVerifyCodeState;
	trustPicker: GetCustomerCodeState;
	getCustomers: GetCustomersShortNameAndCodeState;
	association: GetAssociationFlowState;
}

export const initialState: IState = {
	phoneFlow: phoneFlowStore.initialState,
	tokenFlow: tokenFlowStore.initialState,
	resendCode: resendCodeStore.initialState,
	verifyCode: verifyCodeStore.initialState,
	trustPicker: trustPickerStore.initialState,
	getCustomers: customersStore.initialState,
	association: associationStore.initialState
}

export default function mainReducer(state: IState, action: object) {
	// Receiving previous state here
	const { phoneFlow, tokenFlow, resendCode, verifyCode, trustPicker, getCustomers, association } = state;

	// Receiving current state here
	const currentState = {
		phoneFlow: phoneFlowStore.reducer(phoneFlow, action),
		tokenFlow: tokenFlowStore.reducer(tokenFlow, action),
		resendCode: resendCodeStore.reducer(resendCode, action),
		verifyCode: verifyCodeStore.reducer(verifyCode, action),
		trustPicker: trustPickerStore.reducer(trustPicker, action),
		getCustomers: customersStore.reducer(getCustomers, action),
		association: associationStore.reducer(association, action)
	};

	// Middlewares
	logger(action, state, currentState);

	return currentState;
}
